(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-collage"] && !Shopify.designMode) return;
  try {
    
  // Mobile tap-flip for product cells (desktop uses :hover).
  (function () {
    const init = (root) => {
      if (root.dataset.ccBound) return;
      root.dataset.ccBound = '1';
      root.addEventListener('click', (evt) => {
        if (!matchMedia('(hover: none)').matches) return;
        const cell = evt.target.closest('.cc-cell--product');
        if (!cell) return;
        if (!cell.classList.contains('is-flipped')) {
          evt.preventDefault();
          evt.stopPropagation();
          root.querySelectorAll('.is-flipped').forEach((c) => c !== cell && c.classList.remove('is-flipped'));
          cell.classList.add('is-flipped');
        }
      });
    };
    document.querySelectorAll('[data-collection-collage]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-girl-archetypes"] && !Shopify.designMode) return;
  try {
    
  class ItGirlArchetypes extends HTMLElement {
    connectedCallback() {
      this.activeIndex = 0;
      this.items = Array.from(this.querySelectorAll('[data-ig-item]'));
      this.tabs  = Array.from(this.querySelectorAll('[data-ig-tab]'));
      this.elName     = this.querySelector('[data-ig-active-name]');
      this.elTagline  = this.querySelector('[data-ig-active-tagline]');
      this.elNameEdge = this.querySelector('[data-ig-active-name-edge]');
      this.elNum      = this.querySelector('[data-ig-active-num]');
      this.elVol      = this.querySelector('[data-ig-active-vol]');
      this.elPager    = this.querySelector('[data-ig-pager]');

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.toggle(i));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });
      // Force initial state: ONLY index 0 is open. Otherwise the
      // grid-template-rows: 0fr → 1fr collapse trick can fail under some
      // browsers and leave multiple bodies expanded.
      this.activate(0);
    }

    toggle(index) {
      // On mobile (no hover), tapping the active item collapses it (true accordion).
      // On desktop, tapping always activates (one is always open).
      const isDesktop = matchMedia('(min-width: 990px)').matches;
      if (!isDesktop && index === this.activeIndex) {
        // collapse
        this.items[index]?.classList.remove('is-active');
        this.tabs[index]?.setAttribute('aria-selected', 'false');
        this.tabs[index]?.setAttribute('aria-expanded', 'false');
        this.activeIndex = -1;
        return;
      }
      this.activate(index);
    }

    activate(index) {
      this.activeIndex = index;
      this.items.forEach((it, i) => {
        const active = i === index;
        it.classList.toggle('is-active', active);
        const tab = it.querySelector('[data-ig-tab]');
        if (tab) {
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('aria-expanded', String(active));
        }
      });
      this.updateChrome(index);
    }

    updateChrome(index) {
      const item = this.items[index];
      if (!item) return;
      const total = this.items.length;
      const num = `0${index + 1} / 0${total}`;
      const vols = ['VOL. I', 'VOL. II', 'VOL. III', 'VOL. IV', 'VOL. V'];
      const vol = vols[index] || `VOL. ${index + 1}`;
      const name = item.querySelector('.ig__h-name')?.textContent.trim() || '';
      const tagline = item.querySelector('.ig__tagline')?.textContent.trim() || '';

      if (this.elName) this.elName.textContent = name;
      if (this.elTagline) this.elTagline.textContent = tagline;
      if (this.elNameEdge) this.elNameEdge.textContent = name;
      if (this.elNum) this.elNum.textContent = num;
      if (this.elVol) this.elVol.textContent = vol;
      if (this.elPager) this.elPager.textContent = `${num} — ${vol}`;
    }

    onKey(evt, i) {
      if (evt.key !== 'ArrowRight' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowDown' && evt.key !== 'ArrowUp') return;
      evt.preventDefault();
      const dir = (evt.key === 'ArrowRight' || evt.key === 'ArrowDown') ? 1 : -1;
      const next = (i + dir + this.tabs.length) % this.tabs.length;
      this.activate(next);
      this.tabs[next]?.focus();
    }
  }
  if (!customElements.get('it-girl-archetypes')) {
    customElements.define('it-girl-archetypes', ItGirlArchetypes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["necklace-builder"] && !Shopify.designMode) return;
  try {
    
  class NecklaceBuilder extends HTMLElement {
    constructor() {
      super();
      this.state = { base: null, charms: [] };
      this.draftBase = null;
      this.draftCharm = null;
      this.activePicker = null;
      this.activeBaseType = 'chain';
      this.collections = null;
      this.mode = null;
      this.catalog = null;
      this.maxCharms = 1;
    }

    connectedCallback() {
      // Charm tiles are zoomed from measured pixel boxes, so a viewport change
      // has to re-fit them. Debounced, and bound once so a Theme Editor
      // re-render cannot stack duplicate listeners.
      if (!this._onCharmZoomResize) {
        this._onCharmZoomResize = () => {
          clearTimeout(this._charmZoomTimer);
          this._charmZoomTimer = setTimeout(() => this.applyCharmZooms(), 120);
        };
        window.addEventListener('resize', this._onCharmZoomResize);
      }
      this.currency = this.dataset.currency || 'KWD';
      this.subunits = Number(this.dataset.subunits) || 100;
      this.parentVariantId = this.dataset.parentVariant;
      this.anchorsUrl = this.dataset.anchorsUrl;

      const EMPTY = { label: '', tabs: [], bases: {}, charms: [] };
      const dataEl = this.querySelector('[data-nb-catalog]');
      let raw = null;
      try {
        raw = dataEl ? JSON.parse(dataEl.textContent) : null;
      } catch (err) {
        console.error('[necklace-builder] catalog parse failed', err);
      }
      // Two shapes are accepted: the current {collections:{stack,clasp}} one,
      // and the pre-Clasp flat {bases,charms} one (treated as a lone "stack").
      if (raw && raw.collections) {
        this.collections = raw.collections;
      } else if (raw && raw.bases) {
        this.collections = { stack: Object.assign({ label: 'Stack', tabs: [
          { key: 'chain', label: 'Chain' }, { key: 'cord', label: 'Cord' }, { key: 'stone', label: 'Stone' },
        ] }, raw) };
      } else {
        this.collections = {};
      }
      this.catalog = EMPTY;

      // Load anchor data (per-base bottom-center attach + inner_width fit
      // metric; per-charm bbox + loop_y). Re-render once it arrives.
      this.anchors = { bases: {}, charms: {} };
      if (this.anchorsUrl) {
        fetch(this.anchorsUrl)
          .then((r) => r.json())
          .then((data) => {
            this.anchors = data;
            this.render();
            // Tiles drawn before the anchors landed have no bbox to zoom to,
            // so re-fit everything now that the measurements exist.
            this.applyCharmZooms();
          })
          .catch((err) => console.warn('[necklace-builder] anchors load failed', err));
      }

      // Live stock. `/products.json` is the storefront's own published catalog
      // and carries a per-variant `available` boolean, so one request covers
      // every base, swatch and charm. `null` means "not known yet / request
      // failed" and MUST leave everything buyable — a stock lookup is never
      // allowed to block a sale.
      this.availability = null;
      fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (!data || !data.products) return;
          const map = new Map();
          data.products.forEach((p) => (p.variants || []).forEach((v) => {
            map.set(Number(v.id), v.available !== false);
          }));
          this.availability = map;
          this.refreshStockMarks();
        })
        .catch((err) => console.warn('[necklace-builder] stock load failed', err));

      this.zoneBase = this.querySelector('[data-nb-zone="base"]');
      this.baseImg = this.querySelector('[data-nb-base-img]');
      this.baseTypeEl = this.querySelector('[data-nb-base-type]');
      this.baseTitleEl = this.querySelector('[data-nb-base-title]');
      this.baseSwatchEl = this.querySelector('[data-nb-base-swatch]');
      this.charmsRow = this.querySelector('[data-nb-charms-row]');
      this.overlayRow = this.querySelector('[data-nb-overlay-row]');
      this.priceEl = this.querySelector('[data-nb-price]');
      this.cta = this.querySelector('[data-nb-cta]');
      // The CTA text is overwritten by the cart-add flow ("Adding…", "Added ✓",
      // "Try again"). Keep the server-rendered label so it can be put back;
      // otherwise a stale success message follows the user into another
      // collection on what is still a live add-to-cart button.
      this.ctaDefaultLabel = this.cta ? this.cta.textContent.trim() : 'Make it mine';

      this.modeCurrentEl = this.querySelector('[data-nb-mode-current]');
      this.querySelectorAll('[data-nb-mode]').forEach((btn) =>
        btn.addEventListener('click', () => this.setMode(btn.dataset.nbMode))
      );
      const changeBtn = this.querySelector('[data-nb-change-mode]');
      if (changeBtn) changeBtn.addEventListener('click', () => this.clearMode());

      // A single collection means there is nothing to choose — skip the gate.
      const keys = Object.keys(this.collections);
      if (keys.length === 1) this.setMode(keys[0]);

      this.querySelectorAll('[data-nb-open]').forEach((btn) =>
        btn.addEventListener('click', this.onOpenPicker.bind(this))
      );
      this.querySelectorAll('[data-nb-close]').forEach((btn) =>
        btn.addEventListener('click', this.onClosePicker.bind(this))
      );
      this.querySelectorAll('[data-nb-confirm]').forEach((btn) => {
        // Stash the button's own wording ("Add" / "Add charm") so the sold-out
        // state can borrow the label and hand it back afterwards.
        if (!btn.dataset.nbLabel) btn.dataset.nbLabel = btn.textContent.trim();
        btn.addEventListener('click', this.onConfirm.bind(this));
      });
      this.querySelectorAll('[data-nb-nav]').forEach((btn) =>
        btn.addEventListener('click', this.onNav.bind(this))
      );
      this.querySelectorAll('[data-nb-tab]').forEach((btn) =>
        btn.addEventListener('click', this.onTabClick.bind(this))
      );
      this.querySelectorAll('[data-nb-track]').forEach((track) => {
        track.addEventListener('scroll', () => this.onScroll(track), { passive: true });
        track.addEventListener('click', (e) => this.onTrackClick(e, track));
      });
      this.cta.addEventListener('click', this.onAddToCart.bind(this));
      const sumToggle = this.querySelector('[data-nb-summary-toggle]');
      const sumZone = this.querySelector('[data-nb-summary]');
      if (sumToggle && sumZone) {
        sumToggle.addEventListener('click', () => {
          const expanded = sumZone.dataset.expanded === 'true';
          sumZone.dataset.expanded = expanded ? 'false' : 'true';
          sumToggle.setAttribute('aria-expanded', String(!expanded));
        });
      }
      // Bound once and kept on the instance. Every other listener here sits on
      // a child node and dies with the subtree when the section is re-rendered;
      // these two live on document/window, so without this guard a Theme Editor
      // reload would stack a fresh Escape/arrow handler on every pass.
      if (!this._onKeyDown) {
        this._onKeyDown = this.onKeyDown.bind(this);
        document.addEventListener('keydown', this._onKeyDown);
      }

      this.render();
    }

    disconnectedCallback() {
      if (this._onKeyDown) {
        document.removeEventListener('keydown', this._onKeyDown);
        this._onKeyDown = null;
      }
      if (this._onCharmZoomResize) {
        window.removeEventListener('resize', this._onCharmZoomResize);
        this._onCharmZoomResize = null;
      }
      clearTimeout(this._charmZoomTimer);
    }

    /* ===== Collection mode (Clasp | Stack) ===== */

    setMode(mode) {
      const next = this.collections[mode];
      if (!next) { console.warn('[necklace-builder] unknown collection', mode); return; }
      this.mode = mode;
      this.catalog = next;
      // Selections do not carry across collections — the products differ.
      this.state = { base: null, charms: [] };
      this.draftBase = null;
      this.draftCharm = null;
      this.activeBaseType = (next.tabs && next.tabs[0] && next.tabs[0].key) || Object.keys(next.bases || {})[0] || 'chain';
      this.renderTabs();
      this.populateCharmTrack();
      this.populateBaseTrack(this.activeBaseType);
      if (this.modeCurrentEl) this.modeCurrentEl.textContent = next.label || mode;
      // Each collection names its own base types, so the empty-state prompt moves with it.
      const hintEl = this.querySelector('[data-nb-base-hint]');
      if (hintEl && next.base_hint) hintEl.textContent = next.base_hint;
      // Charm lift is measured in pendant-heights, so it depends on how much
      // of its canvas a charm cutout fills. Stack charms are landscape crops
      // (pendant ~16% of canvas); Clasp charms are square 1254px crops
      // (pendant ~55%). One global value cannot serve both — a collection may
      // override it, otherwise the section setting applies.
      if (next.charm_lift != null) this.style.setProperty('--nb-charm-lift', String(next.charm_lift));
      else this.style.removeProperty('--nb-charm-lift');
      this.dataset.nbStage = 'build';
      this.render();
    }

    clearMode() {
      // A picker can be open when this fires: the modals live outside .nb__tray
      // so the data-nb-stage selectors do not hide them, and there is no focus
      // trap, so Shift+Tab reaches the "Change collection" button from inside a
      // modal. Without this the old collection's modal floats over the chooser
      // with body scroll still locked.
      if (this.activePicker) this.onClosePicker();
      this.mode = null;
      this.state = { base: null, charms: [] };
      this.draftBase = null;
      this.draftCharm = null;
      this.dataset.nbStage = 'choose';
      this.render();
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Tabs mirror the active collection: Stack = Chain|Cord|Stone, Clasp = Cord|Wrap.
    renderTabs() {
      const wrap = this.querySelector('[data-nb-tabs]');
      if (!wrap) return;
      const tabs = (this.catalog.tabs && this.catalog.tabs.length)
        ? this.catalog.tabs
        : Object.keys(this.catalog.bases || {}).map((k) => ({ key: k, label: k }));
      wrap.innerHTML = tabs.map((t, i) => (
        `<button type="button" class="nb-tab${i === 0 ? ' is-active' : ''}" role="tab" ` +
        `data-nb-tab="${this.escAttr(t.key)}" aria-selected="${i === 0 ? 'true' : 'false'}">${this.escAttr(t.label)}</button>`
      )).join('');
      wrap.querySelectorAll('[data-nb-tab]').forEach((btn) =>
        btn.addEventListener('click', this.onTabClick.bind(this))
      );
    }

    populateBaseTrack(baseType) {
      const modal = this.querySelector('[data-nb-modal="base"]');
      if (!modal) return;
      const track = modal.querySelector('[data-nb-track]');
      const items = (this.catalog.bases && this.catalog.bases[baseType]) || [];
      track.innerHTML = items.map((item) => this.renderBaseCard(item, baseType)).join('');
      track.scrollLeft = 0;
      requestAnimationFrame(() => this.onScroll(track));
    }

    populateCharmTrack() {
      const modal = this.querySelector('[data-nb-modal="charm"]');
      if (!modal) return;
      const track = modal.querySelector('[data-nb-track]');
      track.innerHTML = (this.catalog.charms || []).map((c) => this.renderCharmCard(c)).join('');
      requestAnimationFrame(() => {
        this.onScroll(track);
        this.applyCharmZooms(track);
      });
    }

    // ---- Stock -------------------------------------------------------------
    // Every gate below fails OPEN: with no availability map loaded, or a
    // variant the map has never heard of, the answer is "buyable".
    isVariantAvailable(variantId) {
      if (!this.availability) return true;
      const known = this.availability.get(Number(variantId));
      return known === undefined ? true : known;
    }

    // Returns the swatch indexes that can actually be bought, and whether the
    // item as a whole has anything left.
    stockFor(item) {
      const swatches = item.swatches || [];
      if (!swatches.length) {
        return { hasSwatches: false, available: this.isVariantAvailable(item.variant_id), okIndexes: [] };
      }
      const okIndexes = swatches.reduce((acc, sw, i) => {
        if (this.isVariantAvailable(sw.variant_id)) acc.push(i);
        return acc;
      }, []);
      return { hasSwatches: true, available: okIndexes.length > 0, okIndexes };
    }

    // Shared by base and charm cards: swatch strip, chosen default colour, and
    // the sold-out decoration.
    cardParts(item) {
      const stock = this.stockFor(item);
      const swatchList = item.swatches || [];
      // Open on a colour the customer can actually have.
      const initialIdx = stock.okIndexes.length ? stock.okIndexes[0] : 0;
      const swatches = swatchList.map((sw, i) => {
        const styleParts = [`--swatch-image: url('${this.escUrl(sw.image)}')`];
        if (sw.color) styleParts.push(`--swatch-color: ${this.escAttr(sw.color)}`);
        const out = !this.isVariantAvailable(sw.variant_id);
        const label = out ? `${sw.label} — sold out` : sw.label;
        return `<button type="button" class="nb-swatch${i === initialIdx ? ' is-active' : ''}${sw.color ? ' nb-swatch--color' : ''}" data-nb-swatch="${this.escAttr(sw.label)}" data-swatch-image="${this.escAttr(sw.image)}"${sw.color ? ` data-swatch-color="${this.escAttr(sw.color)}"` : ''}${out ? ' disabled aria-disabled="true"' : ''} style="${styleParts.join('; ')};" aria-label="${this.escAttr(label)}"></button>`;
      }).join('');
      return {
        soldOut: !stock.available,
        swatchesBlock: swatches ? `<div class="nb-card__swatches">${swatches}</div>` : '',
        badge: stock.available ? '' : '<span class="nb-card__soldout">Sold out</span>',
        initialImg: swatchList.length ? swatchList[initialIdx].image : item.image,
        initialSwatch: swatchList.length ? swatchList[initialIdx].label : '',
      };
    }

    renderBaseCard(item, baseType) {
      const p = this.cardParts(item);
      return `
        <article class="nb-card${p.soldOut ? ' is-soldout' : ''}" data-nb-card data-id="${this.escAttr(item.id)}" data-base-type="${baseType}" data-price="${item.price}" data-title="${this.escAttr(item.title)}" data-image="${this.escAttr(p.initialImg)}" data-price-display="${this.escAttr(this.formatMoney(item.price))}" data-swatch="${this.escAttr(p.initialSwatch)}"${p.soldOut ? ' data-soldout="1"' : ''}>
          <div class="nb-card__media"><img src="${this.escUrl(p.initialImg)}" alt="${this.escAttr(item.title)}" loading="lazy">${p.badge}</div>
          ${p.swatchesBlock}
        </article>`;
    }

    renderCharmCard(item) {
      // Clasp charms have colour variants, so charm cards carry the same
      // swatch strip as base cards. Stack charms pass an empty array.
      const p = this.cardParts(item);
      return `
        <article class="nb-card${p.soldOut ? ' is-soldout' : ''}" data-nb-card data-kind="charm" data-id="${this.escAttr(item.id)}" data-price="${item.price}" data-title="${this.escAttr(item.title)}" data-image="${this.escAttr(p.initialImg)}" data-price-display="${this.escAttr(this.formatMoney(item.price))}" data-swatch="${this.escAttr(p.initialSwatch)}"${p.soldOut ? ' data-soldout="1"' : ''}>
          <div class="nb-card__media" data-nb-charm-zoom="0.8"><img src="${this.escUrl(p.initialImg)}" alt="${this.escAttr(item.title)}" loading="lazy">${p.badge}</div>
          ${p.swatchesBlock}
        </article>`;
    }

    escAttr(v) {
      return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }
    escUrl(v) {
      const s = String(v || '');
      if (/^javascript:/i.test(s)) return '';
      return s.replace(/"/g, '&quot;');
    }

    onOpenPicker(evt) {
      const key = evt.currentTarget.dataset.nbOpen;
      const modal = this.querySelector(`[data-nb-modal="${key}"]`);
      if (!modal) return;
      // Note: don't block re-opening the charm picker when one is already
      // chosen — that's the "Change charm" flow. The picker itself replaces
      // the existing charm on confirm.

      this.activePicker = key;
      this.draftBase = null;
      this.draftCharm = null;

      // Cancel a pending close for this modal (see onClosePicker).
      if (this._closeTimers && this._closeTimers[key]) {
        window.clearTimeout(this._closeTimers[key]);
        delete this._closeTimers[key];
      }
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      // <html> is the scrolling element in this theme, so locking body alone
      // let the page scroll away behind an open picker.
      document.documentElement.style.overflow = 'hidden';

      if (key === 'base') {
        const startType = this.state.base?.type || this.activeBaseType;
        this.activateTab(startType, { scrollToCurrent: true });
      } else if (key === 'charm') {
        // Pre-scroll to the currently-selected charm if any
        const current = this.state.charms[0];
        if (current) {
          const charmTrack = modal.querySelector('[data-nb-track]');
          const card = charmTrack?.querySelector(`[data-id="${current.id}"]`);
          if (card && charmTrack) {
            requestAnimationFrame(() => {
              charmTrack.scrollLeft = card.offsetLeft - (charmTrack.clientWidth / 2) + (card.clientWidth / 2);
              this.onScroll(charmTrack);
            });
          }
        }
      }

      const track = modal.querySelector('[data-nb-track]');
      if (track) requestAnimationFrame(() => this.onScroll(track));
    }

    onClosePicker(evt) {
      const key = evt?.currentTarget?.dataset?.nbClose || this.activePicker;
      if (!key) return;
      const modal = this.querySelector(`[data-nb-modal="${key}"]`);
      if (!modal) return;
      modal.classList.remove('is-open');
      // Track this timer. Reopening the same picker inside the 300ms close
      // animation would otherwise let the stale timer re-hide a modal that is
      // now meant to be open, leaving an invisible modal with body scroll still
      // locked and no way out. A fast double tap on mobile hits this.
      this._closeTimers = this._closeTimers || {};
      window.clearTimeout(this._closeTimers[key]);
      this._closeTimers[key] = window.setTimeout(() => {
        modal.hidden = true;
        delete this._closeTimers[key];
      }, 300);
      this.activePicker = null;
      this.draftBase = null;
      this.draftCharm = null;
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }

    onConfirm(evt) {
      const key = evt.currentTarget.dataset.nbConfirm;
      if (key === 'base') {
        if (!this.draftBase) return;
        this.state.base = this.draftBase;
      } else if (key === 'charm') {
        if (!this.draftCharm) return;
        // Single-charm builder: confirming a charm always replaces the
        // current selection rather than appending.
        this.state.charms = [this.draftCharm];
      }
      this.render();
      this.onClosePicker();
    }

    removeCharm(id) {
      this.state.charms = this.state.charms.filter((c) => c.id !== id);
      this.render();
    }

    // Availability arrives after mount. Anything already drawn was drawn
    // stock-blind, so redraw it — but never yank a track out from under a
    // customer who is mid-scroll in an open picker.
    refreshStockMarks() {
      if (this.activePicker) return;
      if (this.activeBaseType) this.populateBaseTrack(this.activeBaseType);
      if (this.catalog && this.catalog.charms) this.populateCharmTrack();
    }

    onTabClick(evt) { this.activateTab(evt.currentTarget.dataset.nbTab); }

    activateTab(type, { scrollToCurrent = false } = {}) {
      this.activeBaseType = type;
      const modal = this.querySelector('[data-nb-modal="base"]');
      modal.querySelectorAll('[data-nb-tab]').forEach((btn) => {
        const isActive = btn.dataset.nbTab === type;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', String(isActive));
      });
      this.populateBaseTrack(type);

      if (scrollToCurrent && this.state.base && this.state.base.type === type) {
        const track = modal.querySelector('[data-nb-track]');
        const card = track.querySelector(`[data-id="${this.state.base.item.id}"]`);
        if (card) {
          requestAnimationFrame(() => {
            track.scrollLeft = card.offsetLeft - (track.clientWidth / 2) + (card.clientWidth / 2);
            this.onScroll(track);
          });
        }
      }
    }

    // Centre a card in the carousel.
    //
    // The track is `scroll-snap-type: x mandatory` + `scroll-behavior: smooth`,
    // and a programmatic smooth scroll into a mandatory snap container is not
    // reliable across engines — it can be cancelled outright, which leaves the
    // arrows looking broken. Rather than bet on it, the animation is attempted
    // and then checked: if the track has not moved at all shortly after, jump
    // straight to the target. The customer either gets the glide or an instant
    // move, never a dead button.
    smoothScrollTrack(track, left) {
      const target = Math.max(0, Math.min(Math.round(left), track.scrollWidth - track.clientWidth));
      const from = track.scrollLeft;
      if (Math.abs(target - from) < 1) return;
      track.scrollTo({ left: target, behavior: 'smooth' });
      clearTimeout(track._nbScrollFallback);
      track._nbScrollFallback = setTimeout(() => {
        if (Math.abs(track.scrollLeft - from) < 1) {
          track.scrollTo({ left: target, behavior: 'instant' });
          this.onScroll(track);
        }
      }, 250);
    }

    onNav(evt) {
      const dir = evt.currentTarget.dataset.nbNav;
      const modal = evt.currentTarget.closest('[data-nb-modal]');
      const track = modal?.querySelector('[data-nb-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll('[data-nb-card]'));
      const activeIndex = cards.findIndex((c) => c.classList.contains('is-active'));
      const next = dir === 'next' ? Math.min(cards.length - 1, activeIndex + 1) : Math.max(0, activeIndex - 1);
      const target = cards[next];
      if (!target) return;
      this.smoothScrollTrack(track, target.offsetLeft - (track.clientWidth / 2) + (target.clientWidth / 2));
    }

    onTrackClick(evt, track) {
      const swatch = evt.target.closest('[data-nb-swatch]');
      if (swatch) { evt.stopPropagation(); this.onSwatchPick(swatch); return; }
      const card = evt.target.closest('[data-nb-card]');
      if (!card || card.classList.contains('is-active')) return;
      this.smoothScrollTrack(track, card.offsetLeft - (track.clientWidth / 2) + (card.clientWidth / 2));
    }

    onSwatchPick(swatch) {
      const card = swatch.closest('[data-nb-card]');
      if (!card) return;
      if (swatch.disabled) return;
      card.querySelectorAll('[data-nb-swatch]').forEach((s) => s.classList.toggle('is-active', s === swatch));
      const newImage = swatch.dataset.swatchImage;
      const newLabel = swatch.dataset.nbSwatch;
      const img = card.querySelector('img');
      if (img) {
        img.src = newImage;
        // A colour swap can change the charm's bbox, so re-fit the zoom.
        const zoomHost = img.closest('[data-nb-charm-zoom]');
        if (zoomHost) {
          img.style.transform = '';
          this.applyCharmZooms(zoomHost);
        }
      }
      card.dataset.image = newImage;
      card.dataset.swatch = newLabel;
      if (card.classList.contains('is-active')) {
        const inBase = swatch.closest('[data-nb-modal]')?.dataset.nbModal === 'base';
        if (inBase) this.draftBase = this.readBaseCard(card);
        else this.draftCharm = this.readCharmCard(card);
      }
    }

    onScroll(track) {
      const trackRect = track.getBoundingClientRect();
      const centerX = trackRect.left + trackRect.width / 2;
      const cards = Array.from(track.querySelectorAll('[data-nb-card]'));
      let closest = null;
      let closestDist = Infinity;
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const dist = Math.abs(cardCenter - centerX);
        card.classList.toggle('is-active', false);
        if (dist < closestDist) { closestDist = dist; closest = card; }
      });
      if (closest) {
        closest.classList.add('is-active');
        const modal = track.closest('[data-nb-modal]');
        const isBase = modal?.dataset.nbModal === 'base';
        // A sold-out card still scrolls into the centre — the carousel has no
        // way to skip it — so it simply never becomes the draft, and the Add
        // button below goes dead.
        const soldOut = closest.dataset.soldout === '1';
        if (isBase) this.draftBase = soldOut ? null : this.readBaseCard(closest);
        else this.draftCharm = soldOut ? null : this.readCharmCard(closest);
        this.updateModalMeta(track, closest);
      }
      const modal = track.closest('[data-nb-modal]');
      if (modal) {
        const prevBtn = modal.querySelector('[data-nb-nav="prev"]');
        const nextBtn = modal.querySelector('[data-nb-nav="next"]');
        const activeIdx = cards.indexOf(closest);
        if (prevBtn) prevBtn.disabled = activeIdx <= 0;
        if (nextBtn) nextBtn.disabled = activeIdx >= cards.length - 1;
      }
    }

    updateModalMeta(track, card) {
      const modal = track.closest('[data-nb-modal]');
      if (!modal) return;
      const soldOut = card.dataset.soldout === '1';
      const titleEl = modal.querySelector('[data-nb-modal-title]');
      const priceEl = modal.querySelector('[data-nb-modal-price]');
      if (titleEl) titleEl.textContent = card.dataset.title || '';
      // Say it in the price line rather than the title, so the piece keeps its
      // name and the reason it cannot be picked sits where the money was.
      if (priceEl) priceEl.textContent = soldOut ? 'Sold out' : (card.dataset.priceDisplay || '');
      const confirm = modal.querySelector('[data-nb-confirm]');
      if (confirm) {
        confirm.disabled = soldOut;
        confirm.textContent = soldOut ? 'Sold out' : (confirm.dataset.nbLabel || 'Add');
      }
    }

    readBaseCard(card) {
      return {
        type: card.dataset.baseType,
        item: {
          id: card.dataset.id,
          title: card.dataset.title || '',
          price: Number(card.dataset.price || 0),
          image: card.dataset.image || '',
        },
        swatch: card.dataset.swatch || '',
      };
    }
    readCharmCard(card) {
      return {
        id: card.dataset.id,
        price: Number(card.dataset.price || 0),
        title: card.dataset.title || '',
        image: card.dataset.image || '',
        swatch: card.dataset.swatch || '',
      };
    }

    onKeyDown(evt) {
      if (!this.activePicker) return;
      if (evt.key === 'Escape') { this.onClosePicker(); }
      else if (evt.key === 'ArrowLeft' || evt.key === 'ArrowRight') {
        const dir = evt.key === 'ArrowRight' ? 'next' : 'prev';
        const btn = this.querySelector(`[data-nb-modal="${this.activePicker}"] [data-nb-nav="${dir}"]`);
        if (btn) btn.click();
      }
    }

    /* ===== Render tray ===== */
    render() {
      // BASE zone
      const base = this.state.base;
      this.zoneBase.dataset.state = base ? 'filled' : 'empty';
      if (base) {
        if (this.baseImg.src !== base.item.image) this.baseImg.src = base.item.image;
        this.baseImg.alt = base.item.title || '';
        this.baseImg.hidden = false;
        this.baseTypeEl.textContent = this.capitalize(base.type);
        this.baseTitleEl.textContent = base.item.title;
        if (base.swatch) {
          this.baseSwatchEl.textContent = base.swatch;
          this.baseSwatchEl.hidden = false;
        } else {
          this.baseSwatchEl.hidden = true;
          this.baseSwatchEl.textContent = '';
        }
      } else {
        this.baseImg.hidden = true;
        this.baseImg.removeAttribute('src');
        this.baseTypeEl.textContent = '—';
        this.baseTitleEl.textContent = 'Untitled';
        this.baseSwatchEl.hidden = true;
        this.baseSwatchEl.textContent = '';
      }

      // CHARM zone — single chip with edit/remove. Replaces the chip in
      // place rather than diff/append since there's at most one.
      const charm = this.state.charms[0] || null;
      const zoneCharms = this.querySelector('[data-nb-zone="charms"]');
      const charmCta = this.querySelector('[data-nb-charm-cta]');
      const charmCtaLabel = this.querySelector('[data-nb-charm-cta-label]');
      this.charmsRow.innerHTML = '';
      if (charm) {
        if (zoneCharms) zoneCharms.dataset.state = 'filled';
        if (charmCtaLabel) charmCtaLabel.textContent = 'Change charm';
        const li = document.createElement('li');
        li.className = 'nb__charm-chip';
        li.dataset.charmId = charm.id;
        li.dataset.nbCharmZoom = '0.86';
        li.title = charm.title;
        li.innerHTML = `
          <img src="${this.escUrl(charm.image)}" alt="${this.escAttr(charm.title)}">
          <button type="button" class="nb__charm-chip-remove" aria-label="Remove ${this.escAttr(charm.title)}">×</button>
        `;
        li.querySelector('.nb__charm-chip-remove').addEventListener('click', (e) => {
          e.stopPropagation();
          this.removeCharm(charm.id);
        });
        this.charmsRow.appendChild(li);
        this.applyCharmZooms(li);
      } else {
        if (zoneCharms) zoneCharms.dataset.state = 'empty';
        if (charmCtaLabel) charmCtaLabel.textContent = 'Add charm';
      }

      // Composite overlay: the single charm hangs from the bottom-center
      // of the chain, sized so the pendant fits inside the chain's gap.
      if (this.overlayRow) {
        this.overlayRow.innerHTML = '';
        if (base && charm) {
          const baseKey = this.imageKey(base.item.image);
          const anchor = this.anchors.bases && this.anchors.bases[baseKey];
          const charmKey = this.imageKey(charm.image);
          const charmData = this.anchors.charms && this.anchors.charms[charmKey];

          if (anchor && charmData) {
            // Size the charm from its REAL dimensions, not from layout.
            //
            // builder-anchors.json carries px_per_mm for each base (measured
            // from the cord centreline against the length on the product) and
            // real_w_mm for each charm (from its shoot calibration). Together
            // they give the charm's true width as a share of the base frame,
            // which is what stops a 25mm charm rendering like a 60mm one.
            //
            // The `charm_scale` setting multiplies the result so the size can
            // be tuned in the Theme Editor without a code change. 1 = life-size.
            //
            // Bases or charms with no scale data fall back to the original
            // 1.4x inner_width rule, so nothing can regress.
            const bboxW = Math.max(0.05, charmData.bbox_w_frac || 0.5);
            const scaleRaw = parseFloat(getComputedStyle(this).getPropertyValue('--nb-charm-scale'));
            const charmScale = Number.isFinite(scaleRaw) && scaleRaw > 0 ? scaleRaw : 1;
            let charmCanvasWPct;
            if (anchor.px_per_mm && anchor.width && charmData.real_w_mm) {
              const bodyPct = charmData.real_w_mm * anchor.px_per_mm / anchor.width * 100;
              charmCanvasWPct = Math.min(72, Math.max(4, bodyPct * charmScale / bboxW));
            } else {
              charmCanvasWPct = Math.min(72, (anchor.inner_width || 25) * 1.4 / bboxW);
            }
            const aspect = (charmData.width && charmData.height)
              ? charmData.width / charmData.height
              : 1;
            // Inline-positioned overlay: anchor at attach_x/attach_y, then
            // translate(-bbox_cx*100%, -loop_y*100%) so the visible bbox top
            // sits at the chain's bottom-center attach point.
            const span = document.createElement('span');
            span.className = 'nb__overlay-charm';
            span.dataset.overlayId = charm.id;
            span.style.setProperty('--charm-image', `url('${this.escUrl(charm.image)}')`);
            span.style.setProperty('--charm-w', charmCanvasWPct + '%');
            span.style.setProperty('--charm-aspect', String(aspect));
            span.style.setProperty('--anchor-x', (anchor.attach_x || 50) + '%');
            span.style.setProperty('--anchor-y', (anchor.attach_y || 90) + '%');
            span.style.setProperty('--bbox-cx', String(charmData.bbox_cx || 0.5));
            // Precompute the vertical translate as one percentage so the
            // CSS doesn't have to multiply two unitless custom properties
            // inside calc() (some browsers/Shopify CDN environments collapse
            // that to 0%).
            // 0 is a documented, valid lift ("bail sits below the chain"), so it
            // cannot go through `||` — that would silently turn it into 2.5.
            const liftRaw = getComputedStyle(this).getPropertyValue('--nb-charm-lift');
            const liftParsed = parseFloat(liftRaw);
            const lift = Number.isFinite(liftParsed) ? liftParsed : 2.5;
            const bboxH = charmData.bbox_h_frac || 0.2;
            const loopY = charmData.loop_y || 0;
            // The generic formula assumes a pendant that HANGS from a bail.
            // A bar charm like Cane has no bail — it bridges the two clasp
            // ends — so no value of loop_y/bbox_h places it correctly. Per
            // CLAUDE.md, hand-tuning builder-anchors.json is the contract for
            // outliers; `translate_y_pct` states the answer outright instead
            // of distorting loop_y, which would then lie about where the bail is.
            const override = Number(charmData.translate_y_pct);
            const translateYPct = Number.isFinite(override)
              ? override
              : -(loopY * 100 + lift * bboxH * 100);
            span.style.setProperty('--nb-translate-y', translateYPct.toFixed(2) + '%');
            this.overlayRow.appendChild(span);
          }
        }
      }

      // SUMMARY
      const baseLabelEl = this.querySelector('[data-nb-breakdown-base-label]');
      const baseValueEl = this.querySelector('[data-nb-breakdown-base]');
      if (baseLabelEl) baseLabelEl.textContent = base ? this.capitalize(base.type) : 'Base';
      if (baseValueEl) baseValueEl.textContent = base ? this.formatMoney(base.item.price) : '—';
      const charmsValueEl = this.querySelector('[data-nb-breakdown-charms]');
      if (charmsValueEl) {
        const charmsTotal = this.state.charms.reduce((s, c) => s + c.price, 0);
        charmsValueEl.textContent = charmsTotal ? this.formatMoney(charmsTotal) : '—';
      }
      const total = this.calcTotal();
      const display = total > 0 ? this.formatMoney(total) : '—';
      if (this.priceEl.textContent !== display) {
        this.priceEl.textContent = display;
        this.priceEl.classList.remove('is-flash');
        void this.priceEl.offsetWidth;
        this.priceEl.classList.add('is-flash');
      }
      this.cta.disabled = !this.state.base;
      // Only restore when no request is in flight, so we do not stomp "Adding…".
      if (!this.cartBusy) this.cta.textContent = this.ctaDefaultLabel;
    }

    capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

    /** Strip query/path/extension to get the asset basename key (e.g. "nb-img-chain-paperclip"). */
    imageKey(url) {
      try {
        const u = String(url || '').split('?')[0];
        const file = u.split('/').pop() || '';
        return file.replace(/\.(png|jpe?g|webp)$/i, '');
      } catch (_e) { return ''; }
    }

    /* ===== Charm zoom =====
       The charm photos are shot small on a large transparent canvas (the
       2026-08 set puts the charm at ~26% of a 1536px frame), so a plain
       object-fit render leaves the charm a speck in the middle of the tile.
       Here the charm body is scaled up and re-centred using the bbox already
       measured in builder-anchors.json, which means no re-cropped assets and
       no second copy of each photo. The composite preview keeps using the
       untouched image; this only affects tiles where we WANT the charm large.
    */
    zoomCharmImage(img, target) {
      if (!img) return;
      const data = this.anchors.charms && this.anchors.charms[this.imageKey(img.currentSrc || img.src)];
      // No measurements for this charm: leave it exactly as the browser drew it.
      if (!data || !data.width || !data.height) {
        img.style.transform = '';
        img.style.transformOrigin = '';
        return;
      }
      const box = img.getBoundingClientRect();
      if (!box.width || !box.height) return;

      // object-fit: contain — work out where the image actually sits inside
      // the element box, since the letterboxing shifts the charm's position.
      const fit = Math.min(box.width / data.width, box.height / data.height);
      const drawnW = data.width * fit;
      const drawnH = data.height * fit;
      const bodyW = (data.bbox_w_frac || 1) * drawnW;
      const bodyH = (data.bbox_h_frac || 1) * drawnH;
      if (bodyW <= 0 || bodyH <= 0) return;

      const fill = target || 0.86;
      const zoom = Math.max(1, Math.min(6, Math.min(fill * box.width / bodyW, fill * box.height / bodyH)));
      const cx = ((box.width - drawnW) / 2 + (data.bbox_cx != null ? data.bbox_cx : 0.5) * drawnW) / box.width * 100;
      const cy = ((box.height - drawnH) / 2 + (data.bbox_cy != null ? data.bbox_cy : 0.5) * drawnH) / box.height * 100;

      // Scale about the charm body, then shift that body to the tile centre.
      img.style.transformOrigin = `${cx.toFixed(2)}% ${cy.toFixed(2)}%`;
      img.style.transform = `translate(${(50 - cx).toFixed(2)}%, ${(50 - cy).toFixed(2)}%) scale(${zoom.toFixed(3)})`;
    }

    applyCharmZooms(scope) {
      const root = scope || this;
      root.querySelectorAll('[data-nb-charm-zoom] img').forEach((img) => {
        const run = () => this.zoomCharmImage(img, parseFloat(img.closest('[data-nb-charm-zoom]').dataset.nbCharmZoom) || 0.86);
        if (img.complete && img.naturalWidth) run();
        else img.addEventListener('load', run, { once: true });
      });
    }
    calcTotal() {
      let t = 0;
      if (this.state.base) t += this.state.base.item.price;
      t += this.state.charms.reduce((s, c) => s + c.price, 0);
      return t;
    }
    formatMoney(value) {
      const amount = value / this.subunits;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: this.subunits === 1000 ? 3 : (this.subunits === 1 ? 0 : 2),
          maximumFractionDigits: this.subunits === 1000 ? 3 : (this.subunits === 1 ? 0 : 2),
        }).format(amount);
      } catch (_e) {
        return `${amount.toFixed(this.subunits === 1000 ? 3 : 2)} ${this.currency}`;
      }
    }

    async onAddToCart() {
      if (!this.state.base) {
        this.cta.textContent = 'Pick a base first';
        return;
      }
      const base = this.state.base;
      // The card dataset only carries id/title/price/image, so look up the
      // full record from the catalog to recover the variant_id (and swatches
      // for multi-colour bases).
      const fullBase = (this.catalog?.bases?.[base.type] || []).find((b) => b.id === base.item.id);
      const baseVariantId = !fullBase
        ? null
        : (base.swatch
            ? (fullBase.swatches || []).find((s) => s.label === base.swatch)?.variant_id
            : fullBase.variant_id);
      if (!baseVariantId) {
        this.cta.textContent = 'Not configured';
        console.warn('[necklace-builder] missing variant_id for base', base, fullBase);
        return;
      }
      // Last line of defence. Stock can sell out between page load and this
      // click, and the picker gate only covers what was on screen. Name the
      // piece — "Try again" tells the customer nothing actionable.
      if (!this.isVariantAvailable(baseVariantId)) {
        this.cta.textContent = `${base.item.title} is sold out`;
        return;
      }
      // Group identifier so the cart drawer / future template can visually
      // bundle the lines that came from one builder click.
      const kitId = 'k-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      // Charms with colours carry their variant_id per swatch, not on the item,
      // so an empty or unmatched swatch resolves to undefined. Dropping those
      // silently would post a base-only cart while the summary still showed the
      // charm — the customer pays less and never receives it. Fail loudly and
      // post nothing instead.
      const charmEntries = [];
      for (const c of this.state.charms) {
        const full = (this.catalog?.charms || []).find((x) => x.id === c.id);
        const vid = !full
          ? null
          : (c.swatch
              ? (full.swatches || []).find((sw) => sw.label === c.swatch)?.variant_id
              : full.variant_id);
        if (!vid) {
          console.warn('[necklace-builder] missing variant_id for charm', c, full);
          this.cta.textContent = 'Not configured';
          return;
        }
        if (!this.isVariantAvailable(vid)) {
          this.cta.textContent = `${c.title} is sold out`;
          return;
        }
        charmEntries.push({ variant_id: vid, title: c.title, swatch: c.swatch || '' });
      }
      const items = [
        {
          id: Number(baseVariantId),
          quantity: 1,
          properties: {
            _Kit_ID: kitId,
            _Kit_Role: 'Base',
            _Kit_Type: base.type,
            ...(this.mode ? { _Kit_Collection: this.catalog.label || this.mode } : {}),
            ...(base.swatch ? { _Kit_Color: base.swatch } : {}),
          },
        },
        ...charmEntries.map((c) => ({
          id: Number(c.variant_id),
          quantity: 1,
          properties: {
            _Kit_ID: kitId,
            _Kit_Role: 'Charm',
            _Kit_Type: 'charm',
            ...(this.mode ? { _Kit_Collection: this.catalog.label || this.mode } : {}),
            ...(c.swatch ? { _Kit_Color: c.swatch } : {}),
          },
        })),
      ];
      try {
        this.cartBusy = true;
        this.cta.disabled = true;
        this.cta.textContent = 'Adding…';
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error(await res.text());
        this.cartBusy = false;
        this.cta.textContent = 'Added ✓';
        // Hand the button back so it is not left reading a stale success
        // message, and re-enable it so the kit can be added again.
        window.setTimeout(() => {
          if (!this.cartBusy) {
            this.cta.textContent = this.ctaDefaultLabel;
            this.cta.disabled = !this.state.base;
          }
        }, 2000);
        try {
          const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = cartRes.ok ? await cartRes.json() : null;
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'necklace-builder', data: { source: 'necklace-builder', itemCount: cart?.item_count } },
          }));
        } catch (_e) { /* drawer refresh is best-effort */ }
      } catch (err) {
        console.error('[necklace-builder] cart add failed', err);
        this.cartBusy = false;
        this.cta.textContent = 'Try again';
        this.cta.disabled = false;
      }
    }
  }

  if (!customElements.get('necklace-builder')) {
    customElements.define('necklace-builder', NecklaceBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunstone-hero"] && !Shopify.designMode) return;
  try {
    
  class SunstoneHero extends HTMLElement {
    constructor() {
      super();
      this.lastY = 0;
      this.rot = 0;
      this.ticking = false;
      this.inView = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      if (this.reducedMotion) return;
      this.stages = Array.from(this.querySelectorAll('[data-sh-stage]')).map((stage) => ({
        stage,
        baseImg: stage.querySelector('[data-sh-base]'),
        charms: Array.from(stage.querySelectorAll('[data-sh-charm]')),
        postcard: stage.querySelector('[data-sh-postcard]'),
      }));
      // For viewport / scroll math we use whichever stage is currently visible.
      this.stage = this.stages[0]?.stage;
      if (!this.stage) return;

      this.lastY = window.scrollY;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      // Stop animating once the hero is fully off-screen.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          for (const e of entries) this.inView = e.isIntersecting;
        }, { threshold: 0 });
        this.io.observe(this);
      }

      // Prime the transform once on mount.
      requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.io) this.io.disconnect();
    }

    onScroll() {
      if (!this.inView || this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => this.update());
    }

    update() {
      this.ticking = false;
      const y = window.scrollY;
      const dy = y - this.lastY;
      this.lastY = y;
      this.rot += dy * 1.2;

      for (const { stage, baseImg, charms, postcard } of this.stages) {
        // Skip stages that are hidden via CSS — saves work and avoids
        // animating elements the user can't see.
        if (stage.offsetParent === null) continue;
        if (!baseImg) continue;

        const stageRect = stage.getBoundingClientRect();
        const stageH = stageRect.height || window.innerHeight;
        const scrollFrac = Math.max(0, Math.min(1, -stageRect.top / stageH));

        const py = -scrollFrac * 180;
        const ps = 1.05 + scrollFrac * 0.18;
        const tilt = scrollFrac * -6;
        baseImg.style.setProperty('--sh-py', py.toFixed(2) + 'px');
        baseImg.style.setProperty('--sh-ps', ps.toFixed(3));
        baseImg.style.setProperty('--sh-tilt', tilt.toFixed(2) + 'deg');

        const pushZ = scrollFrac * 120;
        for (const charm of charms) {
          const sign = Number(charm.dataset.shDir) || 1;
          const phase = Number(charm.dataset.shPhase) || 0;
          const localBob = Math.sin((scrollFrac + phase) * Math.PI * 2) * 28;
          const allowRot = charm.dataset.shRotate !== 'false';
          charm.style.setProperty('--sh-rot', allowRot ? (this.rot * sign).toFixed(2) + 'deg' : '0deg');
          charm.style.setProperty('--sh-by', localBob.toFixed(2) + 'px');
          charm.style.setProperty('--sh-bz', pushZ.toFixed(2) + 'px');
        }

        if (postcard) {
          const pcRotMax = Number(postcard.dataset.shRotMax || 6);
          const pcRot = (scrollFrac - 0.5) * 2 * pcRotMax;
          const pcY   = -scrollFrac * 90;
          postcard.style.setProperty('--sh-pc-rot', pcRot.toFixed(2) + 'deg');
          postcard.style.setProperty('--sh-pc-py',  pcY.toFixed(2) + 'px');
        }
      }
    }
  }

  if (!customElements.get('sunstone-hero')) {
    customElements.define('sunstone-hero', SunstoneHero);
  }

  } catch(e) { console.error(e); }
})();
})();
